const BASE = "https://speed.cloudflare.com";

const median = (a) => { const s = [...a].sort((x, y) => x - y); return s[Math.floor(s.length / 2)]; };

export async function measurePing(n = 8) {
  const t = [];
  for (let i = 0; i < n; i++) {
    const t0 = performance.now();
    await fetch(`${BASE}/__down?bytes=0&r=${Math.random()}`, { cache: "no-store" });
    t.push(performance.now() - t0);
  }
  return median(t.slice(1));
}

async function streamDown(bytes, signal, onBytes) {
  const res = await fetch(`${BASE}/__down?bytes=${bytes}&r=${Math.random()}`, { cache: "no-store", signal });
  const reader = res.body.getReader();
  for (;;) {
    const { done, value } = await reader.read();
    if (done) return;
    onBytes(value.length);
  }
}

// Mbps su finestra temporale fissa, con piu' connessioni parallele
export async function measureDownload(seconds = 8, streams = 4, onProgress) {
  const ctrl = new AbortController();
  let total = 0;
  const t0 = performance.now();
  const tick = setInterval(() => onProgress?.((total * 8) / ((performance.now() - t0) / 1000) / 1e6), 400);
  const loop = async () => { while (!ctrl.signal.aborted) await streamDown(25e6, ctrl.signal, (b) => { total += b; }); };
  setTimeout(() => ctrl.abort(), seconds * 1000);
  await Promise.all(Array.from({ length: streams }, () => loop().catch(() => {})));
  clearInterval(tick);
  return (total * 8) / ((performance.now() - t0) / 1000) / 1e6;
}

export async function measureUpload(seconds = 6, streams = 3, onProgress) {
  const chunk = new Uint8Array(2e6);
  let total = 0;
  const t0 = performance.now();
  const end = t0 + seconds * 1000;
  const tick = setInterval(() => onProgress?.((total * 8) / ((performance.now() - t0) / 1000) / 1e6), 400);
  const loop = async () => {
    while (performance.now() < end) {
      await fetch(`${BASE}/__up?r=${Math.random()}`, { method: "POST", body: chunk, cache: "no-store" });
      total += chunk.length;
    }
  };
  await Promise.all(Array.from({ length: streams }, () => loop().catch(() => {})));
  clearInterval(tick);
  return (total * 8) / ((performance.now() - t0) / 1000) / 1e6;
}

const roundRect = (ctx, x, y, w, h, r) => { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.fill(); };

export function renderResultImage({ download, upload, ping, clientName, when }) {
  const c = document.createElement("canvas");
  c.width = 1200; c.height = 680;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0F172A"; ctx.fillRect(0, 0, 1200, 680);
  ctx.fillStyle = "#fff"; ctx.font = "700 44px sans-serif"; ctx.fillText("Speed Test WiFi", 60, 95);
  ctx.fillStyle = "#94A3B8"; ctx.font = "26px sans-serif";
  ctx.fillText(`${clientName ? `${clientName} · ` : ""}${when.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}`, 60, 140);
  const cards = [["DOWNLOAD", download, "Mbps", "#22C55E"], ["UPLOAD", upload, "Mbps", "#38BDF8"], ["PING", ping, "ms", "#F59E0B"]];
  cards.forEach(([label, v, unit, col], i) => {
    const x = 60 + i * 370;
    ctx.fillStyle = "#1E293B"; roundRect(ctx, x, 200, 340, 330, 24);
    ctx.fillStyle = col; ctx.font = "700 28px sans-serif"; ctx.fillText(label, x + 36, 260);
    ctx.fillStyle = "#fff";
    const txt = unit === "ms" ? Math.round(v).toString() : v.toFixed(1);
    ctx.font = `800 ${txt.length > 5 ? 72 : 96}px sans-serif`;
    ctx.fillText(txt, x + 36, 400);
    ctx.fillStyle = "#94A3B8"; ctx.font = "32px sans-serif"; ctx.fillText(unit, x + 36, 460);
  });
  ctx.fillStyle = "#64748B"; ctx.font = "22px sans-serif";
  ctx.fillText("Misurato dal dispositivo del tecnico tramite server Cloudflare · Nureal-Operation", 60, 620);
  return new Promise((resolve) => c.toBlob((b) => resolve(b), "image/jpeg", 0.9));
}
